/* Product-page pattern picker.
   Order: current case, then cases that share a title word, then other
   cases in the same collection. A case with no collection also keeps the
   first 10 cases from the catalog Featured mix. The current case stays
   first. Choosing a circle swaps the product without a full page reload. */
(function () {
  var FEATURED_LEAD = ['amalfi lemon', 'black&pink checkerboard', 'purple sunset', 'trick or treat'];
  var STOP_WORDS = { and: 1, the: 1, for: 1, with: 1, case: 1, phone: 1, cover: 1, from: 1 };

  function titleKey(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s*&\s*/g, '&')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function words(value) {
    var parts = String(value || '')
      .toLowerCase()
      .replace(/&/g, ' ')
      .split(/[^a-z0-9]+/);
    var found = [];
    var seen = {};
    for (var i = 0; i < parts.length; i++) {
      var word = parts[i];
      if (!word || word.length < 3 || STOP_WORDS[word] || seen[word]) continue;
      seen[word] = 1;
      found.push(word);
    }
    return found;
  }

  function sharesWord(currentWords, title) {
    var other = words(title);
    for (var i = 0; i < other.length; i++) {
      if (currentWords.indexOf(other[i]) !== -1) return true;
    }
    return false;
  }

  function collectionList(value) {
    return String(value || '')
      .split(',')
      .map(function (handle) {
        return handle.trim();
      })
      .filter(Boolean);
  }

  function sharesCollection(currentCols, value) {
    if (!currentCols.length) return false;
    var other = collectionList(value);
    for (var i = 0; i < other.length; i++) {
      if (currentCols.indexOf(other[i]) !== -1) return true;
    }
    return false;
  }

  function isOneOff(key) {
    return String(key || '').indexOf('one-') === 0;
  }

  function mixItems(nodes, startLast) {
    var groups = new Map();
    nodes.forEach(function (node, index) {
      var key = node.dataset.acPattern || 'one-' + index;
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(node);
    });

    function keysWith(predicate) {
      var found = [];
      groups.forEach(function (list, key) {
        if (list.length && predicate(key)) found.push(key);
      });
      return found;
    }

    function fullest(keys) {
      keys.sort(function (a, b) {
        return groups.get(b).length - groups.get(a).length;
      });
      return keys[0];
    }

    var last = startLast || null;
    var ordered = [];
    var guard = nodes.length;
    while (guard--) {
      var shared = keysWith(function (key) {
        return !isOneOff(key) && key !== last;
      });
      var ones = keysWith(isOneOff);
      var key = null;
      if (!last || isOneOff(last)) {
        key = shared.length ? fullest(shared) : ones[0];
      } else if (ones.length) {
        key = ones[0];
      } else if (shared.length) {
        key = fullest(shared);
      }
      if (!key) key = keysWith(function () { return true; })[0];
      if (!key) break;
      ordered.push(groups.get(key).shift());
      last = key;
    }
    return ordered;
  }

  function featuredOrder(nodes) {
    var rest = nodes.slice();
    var lead = [];
    FEATURED_LEAD.forEach(function (wanted) {
      for (var i = 0; i < rest.length; i++) {
        if (titleKey(rest[i].dataset.acSortTitle) !== wanted) continue;
        lead.push(rest.splice(i, 1)[0]);
        break;
      }
    });
    var last = lead.length ? lead[lead.length - 1].dataset.acPattern || null : null;
    return lead.concat(mixItems(rest, last));
  }

  function orderItems(items) {
    if (!items.length) return [];
    var current = null;
    for (var i = 0; i < items.length; i++) {
      if (items[i].dataset.current === 'true') {
        current = items[i];
        break;
      }
    }
    if (!current) current = items[0];

    var currentWords = words(current.dataset.acSortTitle);
    var currentCols = collectionList(current.dataset.acCollections);
    var nameMatches = [];
    var collectionMatches = [];

    items.forEach(function (item) {
      if (item === current) return;
      if (sharesWord(currentWords, item.dataset.acSortTitle)) nameMatches.push(item);
      else if (sharesCollection(currentCols, item.dataset.acCollections)) collectionMatches.push(item);
    });

    var ordered = [current].concat(featuredOrder(nameMatches), featuredOrder(collectionMatches));
    if (currentCols.length) return ordered;

    var seen = new Set(ordered);
    var added = 0;
    featuredOrder(items).forEach(function (item) {
      if (added >= 10) return;
      added += 1;
      if (seen.has(item)) return;
      seen.add(item);
      ordered.push(item);
    });
    return ordered;
  }

  var logic = {
    words: words,
    sharesWord: sharesWord,
    featuredOrder: featuredOrder,
    orderItems: orderItems,
  };
  if (typeof window !== 'undefined') window.AcPatternPickerLogic = logic;
  if (typeof globalThis !== 'undefined') globalThis.AcPatternPickerLogic = logic;

  if (typeof document === 'undefined' || typeof customElements === 'undefined' || typeof HTMLElement === 'undefined') {
    return;
  }

  var navToken = 0;
  var navAbort = null;
  var warmedPreviews = {};

  function previewUrl(href) {
    var next = new URL(href, window.location.origin);
    var current = new URL(window.location.href);
    ['preview_theme_id', 'pb', '_fd'].forEach(function (key) {
      if (current.searchParams.has(key)) next.searchParams.set(key, current.searchParams.get(key));
    });
    return next;
  }

  function selectPattern(picker, pathname) {
    var match = null;
    picker.querySelectorAll('[data-ac-pattern-item]').forEach(function (item) {
      var path = '';
      try {
        path = new URL(item.getAttribute('href'), window.location.origin).pathname;
      } catch (error) {
        path = '';
      }
      var on = path === pathname;
      item.classList.toggle('is-selected', on);
      if (on) {
        item.setAttribute('aria-current', 'page');
        match = item;
      } else {
        item.removeAttribute('aria-current');
      }
    });
    return match;
  }

  function patternTrack(picker) {
    return picker ? picker.querySelector('[data-ac-pattern-track]') : null;
  }

  function pinTrackScroll(track, saved) {
    if (!track || !saved) return;
    if (saved.left > 0 && track.scrollLeft === 0) track.scrollLeft = saved.left;
    if (saved.top > 0 && track.scrollTop === 0) track.scrollTop = saved.top;
  }

  function markSelected(link) {
    var picker = link.closest('ac-pattern-picker');
    if (!picker) return;
    picker.querySelectorAll('[data-ac-pattern-item]').forEach(function (item) {
      var on = item === link;
      item.classList.toggle('is-selected', on);
      if (on) item.setAttribute('aria-current', 'page');
      else item.removeAttribute('aria-current');
    });
  }

  function patternLinkForPath(pathname) {
    var links = document.querySelectorAll('ac-pattern-picker [data-ac-pattern-item]');
    for (var i = 0; i < links.length; i++) {
      var path = '';
      try {
        path = new URL(links[i].getAttribute('href'), window.location.origin).pathname;
      } catch (error) {
        path = '';
      }
      if (path === pathname) return links[i];
    }
    return null;
  }

  function heroImage() {
    return document.querySelector('#MainContent .product__media-item.is-active .product__media img')
      || document.querySelector('#MainContent .product__media img');
  }

  function warmPatternImage(link, priority) {
    var url = link && link.getAttribute('data-ac-preview');
    if (!url || warmedPreviews[url]) return;
    warmedPreviews[url] = 1;
    var img = new Image();
    img.decoding = 'async';
    if (priority) img.fetchPriority = priority;
    img.src = url;
  }

  function applyPatternTitle(link) {
    var title = link && link.getAttribute('title');
    if (!title) return;
    document.querySelectorAll('#MainContent .product__title h1, #MainContent .product__title h2').forEach(function (node) {
      node.textContent = title;
    });
  }

  function showPatternPreview(link, token) {
    var url = link && link.getAttribute('data-ac-preview');
    applyPatternTitle(link);
    if (!url) return '';
    warmPatternImage(link, 'high');
    var apply = function () {
      if (token !== navToken) return;
      var img = heroImage();
      if (!img) return;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      if (img.getAttribute('src') !== url) img.setAttribute('src', url);
    };
    var pre = new Image();
    pre.onload = apply;
    pre.src = url;
    if (pre.complete && pre.naturalWidth) apply();
    return url;
  }

  function pinHeroPreview(root, previewUrl) {
    if (!root || !previewUrl) return;
    var hero = root.querySelector('.product__media-item.is-active .product__media img')
      || root.querySelector('.product__media img');
    if (!hero) return;
    hero.setAttribute('src', previewUrl);
    hero.removeAttribute('srcset');
    hero.removeAttribute('sizes');
  }

  function keepPatternStyles() {
    // The circle stylesheet also lives in the product section. Moving that
    // link on click reloads it and the circles briefly jump to the raw image
    // size. Leave it if the head already has a copy.
    var links = document.querySelectorAll('link[rel="stylesheet"]');
    var href = '';
    for (var i = 0; i < links.length; i++) {
      var candidate = links[i].getAttribute('href') || '';
      if (candidate.indexOf('ac-pattern-picker') === -1) continue;
      if (links[i].parentNode === document.head) return;
      href = candidate;
    }
    if (!href) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }

  function abortProductFetches() {
    document.querySelectorAll('product-info, product-recommendations').forEach(function (info) {
      if (!info.abortController) return;
      info.abortController.abort();
      info.abortController = null;
    });
  }

  function renderedControlValue(control) {
    if (!control) return null;
    var selected = control.querySelector('option[selected]');
    if (selected) return selected.getAttribute('value');
    var checked = control.querySelector('input:checked');
    if (checked) return checked.value;
    return control.getAttribute('value');
  }

  function readRenderedVariant(root) {
    var input = root.querySelector('product-form input[name="id"]');
    var selects = [];
    root.querySelectorAll('variant-selects select').forEach(function (select) {
      selects.push({ id: select.id, value: renderedControlValue(select) });
    });
    return {
      variantId: input ? input.getAttribute('value') : null,
      selects: selects,
    };
  }

  function applyRenderedVariant(state) {
    if (!state) return;
    document.querySelectorAll('#MainContent product-form input[name="id"], #MainContent .installment input[name="id"]').forEach(function (input) {
      if (!state.variantId) return;
      var fresh = input.cloneNode(true);
      fresh.disabled = false;
      fresh.value = state.variantId;
      fresh.setAttribute('value', state.variantId);
      input.replaceWith(fresh);
    });
    state.selects.forEach(function (saved) {
      if (!saved.id || saved.value == null) return;
      var select = document.getElementById(saved.id);
      if (!select || select.value === saved.value) return;
      select.value = saved.value;
    });
  }

  function lockAddToCart() {
    document.querySelectorAll('.product-form__submit').forEach(function (button) {
      button.setAttribute('disabled', 'disabled');
      button.setAttribute('aria-disabled', 'true');
    });
  }

  function finishSwap(doc, next, options, previewUrl) {
    var main = document.getElementById('MainContent');
    var newMain = doc.getElementById('MainContent');
    if (!main || !newMain || !newMain.querySelector('product-info')) {
      window.location.assign(next.href);
      return;
    }

    var renderedVariant = readRenderedVariant(newMain);

    var scrollY = window.acPageScrollTop ? window.acPageScrollTop() : window.scrollY;
    var title = doc.querySelector('title');
    if (title && title.textContent) {
      document.title = title.textContent;
    } else {
      var heading = newMain.querySelector('.product__title h1');
      if (heading && heading.textContent) {
        var dash = document.title.indexOf('–');
        var suffix = dash === -1 ? '' : document.title.slice(dash);
        document.title = heading.textContent.trim() + (suffix ? ' ' + suffix : '');
      }
    }
    var canonical = document.querySelector('link[rel="canonical"]');
    var newCanonical = doc.querySelector('link[rel="canonical"]');
    if (canonical && newCanonical) canonical.href = newCanonical.href;
    else if (canonical) {
      try {
        var canon = new URL(canonical.href);
        canon.pathname = next.pathname;
        canon.search = '';
        canon.hash = '';
        canonical.href = canon.href;
      } catch (error) {}
    }

    // The catalog fade-in starts invisible. Drop it so the new case is
    // shown immediately, including on desktop where a hidden slide has no height.
    newMain.querySelectorAll('.scroll-trigger').forEach(function (element) {
      element.classList.remove('scroll-trigger', 'scroll-trigger--offscreen', 'animate--fade-in', 'animate--slide-in');
    });
    pinHeroPreview(newMain, previewUrl);

    // Keep the same circle list. Park it outside the content that is
    // replaced so the row is not rebuilt and its scroll position survives.
    var picker = main.querySelector('ac-pattern-picker');
    var track = patternTrack(picker);
    var savedScroll = track ? { left: track.scrollLeft, top: track.scrollTop } : null;
    var incomingPicker = newMain.querySelector('ac-pattern-picker');
    if (incomingPicker) incomingPicker.remove();
    var park = null;
    if (picker) {
      var rect = picker.getBoundingClientRect();
      park = document.createElement('div');
      park.setAttribute('data-ac-pattern-park', '');
      park.style.cssText = 'position:fixed;left:0;top:0;width:' + rect.width + 'px;height:' + Math.max(rect.height, 1) + 'px;visibility:hidden;pointer-events:none;overflow:hidden;z-index:-1;';
      document.body.appendChild(park);
      park.appendChild(picker);
      pinTrackScroll(track, savedScroll);
    }
    abortProductFetches();
    keepPatternStyles();
    main.innerHTML = newMain.innerHTML;
    var media = main.querySelector('.product__media-wrapper');
    if (picker && media) media.appendChild(picker);
    if (park) park.remove();
    pinTrackScroll(track, savedScroll);
    applyRenderedVariant(renderedVariant);
    requestAnimationFrame(function () {
      applyRenderedVariant(renderedVariant);
      pinTrackScroll(track, savedScroll);
    });
    if (picker) selectPattern(picker, next.pathname);
    if (options.push) {
      history.pushState({ acPatternPicker: true, scrollY: scrollY }, '', next.pathname + next.search + next.hash);
    }
    try {
      sessionStorage.setItem('ac-last-product', next.pathname + next.search);
      sessionStorage.removeItem('ac-404-bounce');
    } catch (error) {}
    if (window.acSetPageScrollTop) window.acSetPageScrollTop(scrollY);
    else if (Math.abs(window.scrollY - scrollY) > 1) window.scrollTo(0, scrollY);

    if (window.Shopify && window.Shopify.PaymentButton) window.Shopify.PaymentButton.init();
    if (typeof window.initializeScrollAnimationTrigger === 'function') {
      window.initializeScrollAnimationTrigger(main);
    }
    document.dispatchEvent(new CustomEvent('ac:product-tags:refit'));
  }

  function mainSectionIds() {
    var main = document.getElementById('MainContent');
    if (!main) return [];
    var ids = [];
    for (var i = 0; i < main.children.length; i++) {
      var id = main.children[i].id || '';
      if (id.indexOf('shopify-section-') !== 0) continue;
      ids.push(id.slice('shopify-section-'.length));
    }
    return ids;
  }

  function documentFromSections(text, ids) {
    var data;
    try {
      data = JSON.parse(text);
    } catch (error) {
      return null;
    }
    var parts = [];
    var sawProduct = false;
    for (var i = 0; i < ids.length; i++) {
      var html = data[ids[i]];
      if (typeof html !== 'string' || !html) continue;
      if (html.indexOf('product-info') !== -1) sawProduct = true;
      parts.push(html);
    }
    if (!sawProduct) return null;
    return new DOMParser().parseFromString(
      '<!doctype html><html><body><main id="MainContent">' + parts.join('') + '</main></body></html>',
      'text/html'
    );
  }

  function swapProduct(href, options) {
    var next = previewUrl(href);
    if (next.pathname === window.location.pathname && options.push) return Promise.resolve();

    var token = ++navToken;
    if (navAbort) navAbort.abort();
    abortProductFetches();
    navAbort = new AbortController();
    document.documentElement.classList.add('ac-pattern-nav');
    lockAddToCart();

    var previewSrc = showPatternPreview(patternLinkForPath(next.pathname), token);
    var sectionIds = mainSectionIds();
    var fetchUrl = new URL(next.href);
    fetchUrl.searchParams.set('ac_swap', '1');
    if (sectionIds.length) fetchUrl.searchParams.set('sections', sectionIds.join(','));

    return fetch(fetchUrl.href, { signal: navAbort.signal, credentials: 'same-origin', priority: 'low' })
      .then(function (response) {
        if (!response.ok) {
          var failure = new Error('pattern picker fetch failed');
          failure.status = response.status;
          throw failure;
        }
        return response.text();
      })
      .then(function (html) {
        if (token !== navToken) return;
        var doc = sectionIds.length && html.trim().charAt(0) === '{'
          ? documentFromSections(html, sectionIds)
          : new DOMParser().parseFromString(html, 'text/html');
        if (!doc) {
          window.location.assign(next.href);
          return;
        }
        finishSwap(doc, next, options, previewSrc);
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        if (token !== navToken) return;
        if (error && error.status === 404) return;
        window.location.assign(next.href);
      })
      .finally(function () {
        if (token === navToken) document.documentElement.classList.remove('ac-pattern-nav');
      });
  }

  var gesture = null;
  var stickScroll = null;

  function forceTrackScroll(track, saved) {
    if (!track || !saved) return;
    if (track.scrollLeft !== saved.left) track.scrollLeft = saved.left;
    if (track.scrollTop !== saved.top) track.scrollTop = saved.top;
  }

  function holdTrack(track, saved) {
    if (!track || !saved) return;
    stickScroll = {
      track: track,
      left: saved.left,
      top: saved.top,
      until: performance.now() + 700,
    };
    forceTrackScroll(track, saved);
    requestAnimationFrame(function () {
      if (!stickScroll) return;
      forceTrackScroll(stickScroll.track, stickScroll);
      requestAnimationFrame(function () {
        if (stickScroll) forceTrackScroll(stickScroll.track, stickScroll);
      });
    });
  }

  function patternLink(target) {
    var link = target && target.closest ? target.closest('[data-ac-pattern-item]') : null;
    if (!link || !link.closest('ac-pattern-picker')) return null;
    return link;
  }

  function choosePattern(link) {
    if (!link || link.dataset.acChosen === '1') return;
    var next = previewUrl(link.getAttribute('href'));
    if (next.pathname === window.location.pathname) return;
    link.dataset.acChosen = '1';
    window.setTimeout(function () {
      delete link.dataset.acChosen;
    }, 400);
    markSelected(link);
    document.dispatchEvent(new CustomEvent('ac:pattern-select', {
      bubbles: true,
      detail: { href: link.href },
    }));
  }

  function onPatternPointerDown(event) {
    if (event.pointerType === 'mouse' && event.button !== 0) return;
    var link = patternLink(event.target);
    if (!link) return;
    var track = link.closest('[data-ac-pattern-track]');
    if (track && track.dataset.acGliding === '1') return;
    stickScroll = null;
    // A phone tap focuses the circle and the browser slides it to the start
    // of the row. Keep the row where it is; the ring shows the choice.
    try {
      link.focus({ preventScroll: true });
    } catch (error) {}
    gesture = {
      id: event.pointerId,
      link: link,
      x: event.clientX,
      y: event.clientY,
      scroll: track ? track.scrollLeft : 0,
      scrollTop: track ? track.scrollTop : 0,
      track: track,
      moved: false,
    };
    warmPatternImage(link, 'high');
  }

  function onPatternPointerMove(event) {
    if (!gesture || event.pointerId !== gesture.id || gesture.moved) return;
    var slop = event.pointerType === 'touch' ? 28 : 10;
    if (Math.abs(event.clientX - gesture.x) > slop || Math.abs(event.clientY - gesture.y) > slop) {
      gesture.moved = true;
    }
  }

  var ignoreClickUntil = 0;

  function onPatternPointerUp(event) {
    if (!gesture || event.pointerId !== gesture.id) return;
    var current = gesture;
    gesture = null;
    var track = current.track;
    // A press that did not drag is a choice, even if the browser scrolled
    // the circle into view. That scroll was cancelling desktop clicks.
    if (current.moved) {
      ignoreClickUntil = performance.now() + 400;
      return;
    }
    if (track) holdTrack(track, { left: current.scroll, top: current.scrollTop });
    choosePattern(current.link);
  }

  function onPatternClick(event) {
    var link = patternLink(event.target);
    if (!link) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (event.button && event.button !== 0) return;
    if (performance.now() < ignoreClickUntil) return;
    var row = link.closest('[data-ac-pattern-track]');
    if (row && row.dataset.acGliding === '1') return;
    choosePattern(link);
  }

  function onPopState(event) {
    if (!event.state || event.state.acPatternPicker !== true) return;
    if (!window.location.pathname.includes('/products/')) return;
    if (!document.querySelector('ac-pattern-picker')) return;
    var info = document.querySelector('product-info');
    var shown = info && info.dataset.url ? info.dataset.url.split('?')[0] : '';
    if (shown === window.location.pathname) return;
    swapProduct(window.location.href, { push: false });
  }

  function bindTrack(track) {
    if (!track || track.dataset.acBound === 'true') return;
    track.dataset.acBound = 'true';
    var timer = 0;
    track.addEventListener('scroll', function () {
      if (stickScroll && stickScroll.track === track && performance.now() < stickScroll.until) {
        if (gesture && gesture.moved) stickScroll = null;
        else {
          forceTrackScroll(track, stickScroll);
          return;
        }
      }
      if (gesture && !gesture.moved && gesture.track === track) {
        if (track.scrollLeft !== gesture.scroll) track.scrollLeft = gesture.scroll;
        if (track.scrollTop !== gesture.scrollTop) track.scrollTop = gesture.scrollTop;
        return;
      }
      track.dataset.acGliding = '1';
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        delete track.dataset.acGliding;
      }, 140);
    }, { passive: true });
  }

  function updateOverflow(picker) {
    var nav = picker.querySelector('.ac-pattern-picker__nav');
    var track = picker.querySelector('[data-ac-pattern-track]');
    if (!nav || !track) return;
    var overflows = track.scrollWidth > track.clientWidth + 2 || track.scrollHeight > track.clientHeight + 2;
    nav.classList.toggle('is-overflowing', overflows);
  }

  class AcPatternPicker extends HTMLElement {
    connectedCallback() {
      bindTrack(patternTrack(this));
      if (!this._acResize && typeof ResizeObserver !== 'undefined') {
        var picker = this;
        this._acResize = new ResizeObserver(function () {
          updateOverflow(picker);
        });
        this._acResize.observe(this);
      }
      if (this.dataset.acReady === 'true') return;
      this.dataset.acReady = 'true';
      try {
        this.order();
      } finally {
        this.removeAttribute('data-pending');
        var picker = this;
        updateOverflow(picker);
        requestAnimationFrame(function () {
          updateOverflow(picker);
        });
      }
    }

    order() {
      var track = this.querySelector('[data-ac-pattern-track]');
      if (!track) return;
      var items = Array.prototype.slice.call(track.querySelectorAll('[data-ac-pattern-item]'));
      var ordered = orderItems(items);
      if (ordered.length < 2) {
        this.hidden = true;
        return;
      }
      var keep = new Set(ordered);
      items.forEach(function (item) {
        if (!keep.has(item)) item.remove();
      });
      ordered.forEach(function (item, index) {
        var selected = index === 0;
        item.classList.toggle('is-selected', selected);
        if (selected) item.setAttribute('aria-current', 'page');
        else item.removeAttribute('aria-current');
        var img = item.querySelector('img');
        if (img && index < 8) {
          img.loading = 'eager';
          if (!img.complete) {
            var src = img.getAttribute('src');
            if (src) img.setAttribute('src', src);
          }
        }
        track.appendChild(item);
      });
      track.scrollLeft = 0;
    }
  }

  if (!customElements.get('ac-pattern-picker')) {
    customElements.define('ac-pattern-picker', AcPatternPicker);
  }

  if (!window.__acPatternPickerBound) {
    window.__acPatternPickerBound = true;
    // Focusing a circle on press scrolls the track. Keep the press from
    // moving focus so the list stays where the shopper left it.
    document.addEventListener('pointerenter', function (event) {
      var link = patternLink(event.target);
      if (link) warmPatternImage(link, 'low');
    }, true);
    document.addEventListener('pointerdown', onPatternPointerDown);
    document.addEventListener('pointermove', onPatternPointerMove);
    document.addEventListener('pointerup', onPatternPointerUp);
    document.addEventListener('pointercancel', function () {
      gesture = null;
    });
    document.addEventListener('ac:pattern-select', function (event) {
      if (!event.detail || !event.detail.href) return;
      swapProduct(event.detail.href, { push: true });
    });
    document.addEventListener('submit', function (event) {
      if (!document.documentElement.classList.contains('ac-pattern-nav')) return;
      var form = event.target;
      if (!form || !form.closest || !form.closest('product-form')) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);
    document.addEventListener('click', onPatternClick, true);
    window.addEventListener('popstate', onPopState);
    window.addEventListener('resize', function () {
      document.querySelectorAll('ac-pattern-picker').forEach(updateOverflow);
    });
  }
})();
